import moment from 'moment';
import React, { Component } from 'react';
import { connect } from "react-redux";
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import '../../stylesheet/dashboard.css';
import '../../stylesheet/profilecard.css';
import CardDesign from '../carddesign/carddesign.jsx';
import LeftLink from '../leftlink/leftlink.jsx';
import AuthNavbar from '../navigation/authnavigation.jsx';
import { Link, NavLink, withRouter } from 'react-router-dom';
import logo from "../../images/SIMSLogo.png";

// import noCards from '../../images/noImage.jpg'


const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    cardState: state.getCardReducer.cardState,
    display: state.getCardReducer.display,
    profileState: state.getProfileReducer.profileState,
    optionState: state.selectedTabReducer.selectedTabReducer,
})
const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
    fetchCard(state) {
        dispatch(
            actions.getCardAction(state)
        )
    },

    clearInput() {
        dispatch(
            actions.clearInputAction()
        )
    },
    clearProfile() {
        dispatch(
            actions.clearProfileAction()
        )
    },

})

const JSEncrypt = window.JSEncrypt
class CardInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCard: {},

            loader: true,
            useClass: "",
            lastSuccessfulLogin: localStorage.getItem('lastSuccessfulLogin'),
            lastUnsuccessfulLogin: localStorage.getItem('lastUnsuccessfulLogin'),
            // cardState: []
        }
        this.handleCardClick = this.handleCardClick.bind(this)
    }

    handleCardClick(state) {
        this.setState({
            selectedCard: state
        }, () => {
            this.setState({
                useClass: "tile"
            })

            // if (status === "Not Activated") {
            //     this.setState({
            //         useClass: "natile"
            //     })
            // } else if (status === "Activated") {
            //     this.setState({
            //         useClass: "tile"
            //     })
            // } else {
            //     this.setState({
            //         useClass: "cltile"
            //     })
            // }
            document.getElementById("tilediv").style.display = "block"

        })
    }


    getMyMonth(cmonth) {
        if (cmonth === 0) {
            return cmonth = "January"
        } else if (cmonth === 1) {
            return cmonth = "February"
        } else if (cmonth === 2) {
            return cmonth = "March"
        } else if (cmonth === 3) {
            return cmonth = "April"
        } else if (cmonth === 4) {
            return cmonth = "May"
        } else if (cmonth === 5) {
            return cmonth = "June"
        } else if (cmonth === 6) {
            return cmonth = "July"
        } else if (cmonth === 7) {
            return cmonth = "August"
        } else if (cmonth === 8) {
            return cmonth = "September"
        } else if (cmonth === 9) {
            return cmonth = "October"
        } else if (cmonth === 10) {
            return cmonth = "November"
        } else if (cmonth === 11) {
            return cmonth = "December"
        }
    }
    componentWillMount() {
        this.props.fetchPublicKey(false);
        localStorage.setItem("comp", "othercomp")
        localStorage.setItem('taboption', 'tab1')

    }
    // componentWillReceiveProps(nextpProps){

    //     if(nextpProps.cardState.status !== 200){
    //         this.setState({
    //             loader:true
    //         })
    //     }
    //     else{
    //         this.setState({
    //             loader:false
    //         })
    //     }
    // }

    componentDidMount() {
        localStorage.setItem("landing", false)
        const { publicKey } = this.props
        let _this = this


        //document.getElementById("tilediv").style.display = "none"
        // this.props.cardSelected === true ?
        //     this.setState({
        //         selectedCard: this.props.selectedNewCard
        //     })
        //     :

        setTimeout(function () {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);

                const state = {
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }
                _this.props.fetchCard(state)
            }
        }, 500);


        // if (time1 < curDate) {

        //     localStorage.clear();
        //     this.props.history.push("/logout")

        // }
    }






    formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }
    getLocalTime = (key) => {

        let local = localStorage.getItem(key)


        let spiltArray = local.split(" ");
        let indDate = spiltArray[0].split("/")

        let utcDateString = indDate[2] + "/" + indDate[1] + "/" + indDate[0] + " " + spiltArray[1]

        let utcobj = new Date(utcDateString)
        let utctimestamp = utcobj.getTime()

        let d = new Date()
        let localOffset = d.getTimezoneOffset() * 60000;


        // let utc = localTime + localOffset;

        let localTime = utctimestamp - localOffset

        let utcdate = new Date(localTime);

        let localTimeToDisplay = utcdate.toLocaleString().split(",")

        return localTimeToDisplay[0] + " " + this.formatAMPM(utcdate)

    }
    getUnLocalTime = (key1) => {

        let local = localStorage.getItem(key1)


        let spiltArray = local.split(" ");
        let indDate = spiltArray[0].split("/")

        let utcDateString = indDate[2] + "/" + indDate[1] + "/" + indDate[0] + " " + spiltArray[1]

        let utcobj = new Date(utcDateString)
        let utctimestamp = utcobj.getTime()

        let d = new Date()
        let localOffset = d.getTimezoneOffset() * 60000;


        // let utc = localTime + localOffset;

        let localTime = utctimestamp - localOffset

        let utcdate = new Date(localTime);

        let localTimeToDisplay = utcdate.toLocaleString().split(",")

        return localTimeToDisplay[0] + " " + this.formatAMPM(utcdate)

    }


    render() {
        localStorage.setItem("landing", false)
        const { selectedCard, useClass, lastSuccessfulLogin, lastUnsuccessfulLogin } = this.state
        const { cardState, profileState, selectedNewCard } = this.props
        console.log('')



        // localStorage.setItem("mailingId", profileState.body.mailingInformation.mailingId || null)
        return (
            <div className="container p-3" >
                <div className="row">
                    <div className="col-sm-12  mb-4 mt-2 pr-0 mr-0" style={{}}>
                        <div className="row">
                            {/* <div className="col-md-12 col-sm-12 ">
                                <div className="row">
                                    <div className="col-md-6  tilepadding">
                                        <label className="tilecontent mr-4"><b>Card Account : </b></label>
                                        <span className="tileheadername">{selectedNewCard && selectedNewCard.length > 0 && selectedNewCard[0].cardNumber}
                                        </span>
                                    </div>
                                </div>
                            </div> */}
                            <div className="col-md-12 mb-6" style={{}} >

                                <div className={"box animated zoomIn "} id="tilediv" style={{ display: "block" }}>
                                    <div className="row">
                                        <div className="col-md-3 col-sm-12" >
                                            <div className="row">
                                                <div className="col-md-12 pl-0 ">
                                                    <label className="tilecontent" style={{ fontSize: "16px", fontWeight: "600" }}>Available Balance: </label>
                                                </div>
                                                <div className="col-md-12 text-left pl-0 " style={{ fontSize: "20px", fontWeight: "600" }}>
                                                    <span className="tileheadername">

                                                        {selectedNewCard && selectedNewCard.length > 0 && selectedNewCard && selectedNewCard[0].availableBalance}
                                                        {/* {selectedNewCard && selectedNewCard[0].availableBalance || "NA"}  */}
                                                    </span><br />
                                                </div>

                                            </div>
                              
                                        </div>

                                        <div className="col-md-5">
                                            <div className="row">
                                                <div className="col-6  text-left nopadding" style={{ fontWeight: "600" }}>
                                                    <label className="tilecontent"> Name on Card: </label>
                                                </div>
                                                <div className="col-6 text-left nopadding">
                                                    <span className="tileheadername">
                                                        {selectedNewCard && selectedNewCard.length > 0 && selectedNewCard && selectedNewCard[0].firstName + " " + selectedNewCard[0].lastName}

                                                        {/* {selectedNewCard && selectedNewCard[0].firstName + " " + selectedNewCard[0].lastName} */}
                                                    </span><br />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-6 text-left nopadding" style={{ fontWeight: "600" }}>
                                                    <label className="tilecontent">Card Status: </label>
                                                </div>
                                                <div className="col-6 text-left nopadding"    >
                                                    <span className={selectedNewCard && selectedNewCard.length > 0 && selectedNewCard && selectedNewCard[0].cardStatusCode === "LOCKED" ? "text-danger" :selectedNewCard && selectedNewCard.length > 0 && selectedNewCard && selectedNewCard[0].cardStatusCode === "BLOCKED" ? "text-danger" : "text-success"}>
                                                        {selectedNewCard && selectedNewCard.length > 0 && selectedNewCard && selectedNewCard[0].cardStatus}
                                                    </span><br />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            {/* <div className="row">
                                                <div className="col-md-5 text-left nopadding" style={{ fontWeight: "600" }}>
                                                    <label className="tilecontent">KYC Status: </label>
                                                </div>
                                                <div className="col-md-7 text-left nopadding">
                                                    <span className={selectedNewCard && selectedNewCard.length > 0 && selectedNewCard && selectedNewCard[0].kycStatus === "Verified" ? "text-success" : selectedNewCard && selectedNewCard.length > 0 && selectedNewCard && selectedNewCard[0].kycStatus === "Pending" ? "text-warning" : "text-danger"}>
                                                        {selectedNewCard && selectedNewCard.length > 0 && selectedNewCard && selectedNewCard[0].kycStatus}
                                                    </span><br />
                                                    {selectedNewCard && selectedNewCard.length > 0 && selectedNewCard && selectedNewCard[0].kycStatus === "Verified" &&
                                                        <div className="col-md-7 tooltip" style={{ top: "0px", textAlign: "right" }}>
                                                            <i className="fa fa-question-circle" aria-hidden="true"></i>
                                                            <span className="tooltiptext text-left" style={{ fontSize: "12px", width: "350px", top: "25px", top: "-50px" }} >
                                                                <label className='ml-3'> <label style={{ color: "green" }}>Verified: </label> Congratulations, your card is ready to use</label>
                                                            </span>
                                                        </div>}
                                                    {selectedNewCard && selectedNewCard.length > 0 && selectedNewCard && selectedNewCard[0].kycStatus === "Failed" &&
                                                        <div className="col-md-7 tooltip" style={{ top: "0px", textAlign: "right" }}>
                                                            <i className="fa fa-question-circle" aria-hidden="true"></i>
                                                            <span className="tooltiptext text-left" style={{ fontSize: "12px", width: "350px", top: "25px", top: "-70px" }} >
                                                                <label className='ml-3'> <label style={{ color: "red" }}>Failed: </label> Your verification is under review, please contact us to complete your verification with one of our team members.</label>
                                                            </span>
                                                        </div>}
                                                    {selectedNewCard && selectedNewCard.length > 0 && selectedNewCard && selectedNewCard[0].kycStatus === "Pending" &&
                                                        <div className="col-md-7 tooltip" style={{ top: "0px", textAlign: "right" }}>
                                                            <i className="fa fa-question-circle" aria-hidden="true"></i>
                                                            <span className="tooltiptext text-left" style={{ fontSize: "12px", width: "350px", top: "25px", top: "-70px" }} >
                                                                <label className='ml-3'> <label style={{ color: "orange" }}>Pending: </label>Your verification is under review, please contact us to complete your verification with one of our team members.</label>
                                                            </span>
                                                        </div>}
                                                </div>
                                            </div> */}

                                            <div className="row">
                                                <div className="col-6  text-left nopadding" style={{ fontWeight: "600" }}>
                                                    <label className="tilecontent">Card Reference ID: </label>
                                                </div>
                                                <div className="col-6  text-left nopadding">
                                                    <span className="tileheadername">
                                                        {selectedNewCard && selectedNewCard.length > 0 && selectedNewCard && selectedNewCard[0].kitNo}
                                                    </span><br />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-6 text-left nopadding" style={{ fontWeight: "600" }}>
                                                    <label className="tilecontent">KlickEx ID: </label>
                                                </div>
                                                <div className="col-6 text-left nopadding">
                                                    <span>
                                                        {selectedNewCard && selectedNewCard.length > 0 && selectedNewCard && selectedNewCard[0].cardholderId}
                                                    </span><br />
                                                </div>
                                            </div>

                                        </div>
                                        {/* <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Last Credit Posted </label>
                                                                </div>
                                                                <div className="col-md-6 text-left tilepadding">
                                                                    <span className="tileheadername"> : {cardState[0].lastCreditPosted || "NA"} </span><br />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Last Debit Posted </label>
                                                                </div>
                                                                <div className="col-md-6 text-left tilepadding">
                                                                    <span className="tileheadername"> : {cardState.body[0].lastDebitPosted || "NA"}  </span><br />
                                                                </div>
                                                                </div>*/}

                                        {/* <div className="col-md-7 col-sm-12">
                                                        <div className="row">
                                                            <div className="col-md-5 tilepadding">
                                                                <label className="tilecontent">Ledger Balance </label>
                                                            </div>
                                                            <div className="col-md-7 text-left tilepadding">
                                                                <span className="tileheadername">{cardState.body[0].ledgerBalance || "NA"}  </span><br />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-5 tilepadding">
                                                                <label className="tilecontent">Last Credit Posted </label>
                                                            </div>
                                                            <div className="col-md-6 text-left tilepadding">
                                                                <span className="tileheadername">{cardState.body[0].lastCreditPosted || "NA"} </span><br />
                                                            </div>
                                                        </div> */}
                                        {/* <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Last Statement Closing Balance </label>
                                                                </div>
                                                                <div className="col-md-7 text-left tilepadding">
                                                                    <span className="tileheadername"> : {selectedCard.lastStatementClosingBalance || "NA"}  </span><br />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Current Statement Balance </label>
                                                                </div>
                                                                <div className="col-md-7 text-left tilepadding">
                                                                    <span className="tileheadername"> : {selectedCard.currentStatementBalance || "NA"}  </span><br />
                                                                </div>
                                                            </div> */}

                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CardInfo.defaultProps = {
    cardState: {
        status: 400
    },
    profileState: {
        status: 400
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CardInfo);


// WEBPACK FOOTER //
// ./src/components/dashboard/cardlist.jsx